import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloseOnboarding = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.22505 18.825L5.17505 17.775L10.95 12L5.17505 6.22499L6.22505 5.17499L12 10.95L17.775 5.17499L18.825 6.22499L13.05 12L18.825 17.775L17.775 18.825L12 13.05L6.22505 18.825Z",
		fill: "#118AB2"
	})
});
export default SvgCloseOnboarding;
